import { UseQueryOptions } from '@tanstack/react-query';

export enum ThoughtspotQueryKey {
  USER_DETAILS = 'userDetails',
  USER_LIVEBOARDS = 'userLiveboards',
  METADATA_EXPORT = 'metadataExport'
}

export const getThoughspotUserFetch = (email: string) =>
  fetch(`${process.env.SETVI_THOUGHTSPOT}/api/AuthHttpTriggerFunction`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      APIKey: 'B3i1JV4zZwoCKHmTlPr2gitMHHsLXaZomLRMlAaWVSeVmS3SQmZZAxO8HrTU2CJ0'
    },
    body: JSON.stringify({ username: email })
  }).then(response => {
    if (response.status === 400) {
      // User not found, return null or empty response
      return null;
    }
    return response.json();
  });

export const getThoughspotUser = (email: string): UseQueryOptions<any> => ({
  queryKey: [ThoughtspotQueryKey.USER_DETAILS, email],
  queryFn: () => getThoughspotUserFetch(email),
  cacheTime: 0,
  staleTime: 300000,
  retry: false
});

export const getThoughtspotMetadata = ({
  thoughspotUserAccessToken,
  body
}: {
  body: any;
  thoughspotUserAccessToken: string;
}): UseQueryOptions<any[]> => ({
  queryKey: [
    ThoughtspotQueryKey.USER_LIVEBOARDS,
    thoughspotUserAccessToken,
    body
  ],
  queryFn: () =>
    fetch('https://setvi.thoughtspot.cloud/api/rest/2.0/metadata/search', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${thoughspotUserAccessToken}`
      },
      body: JSON.stringify({
        dependent_object_version: 'V2',
        include_auto_created_objects: false,
        include_dependent_objects: false,
        dependent_objects_record_size: 50,
        include_details: false,
        include_headers: false,
        include_hidden_objects: false,
        include_incomplete_objects: false,
        include_visualization_headers: false,
        record_offset: 0,
        record_size: 100,
        include_stats: false,
        metadata: [{ type: 'LIVEBOARD' }],
        ...body
      })
    }).then(response => response.json()),
  onError: () => {}, // On some links this throw generic Error
  enabled: !!thoughspotUserAccessToken,
  cacheTime: 0
});

export const exportThoughtspotMetadata = ({
  thoughspotUserAccessToken,
  body
}: {
  body: {
    metadata: Array<{ type: string; identifier: string }>;
    edoc_format?: string;
    export_associated?: boolean;
  };
  thoughspotUserAccessToken: string;
}): UseQueryOptions<any> => ({
  queryKey: [
    ThoughtspotQueryKey.METADATA_EXPORT,
    thoughspotUserAccessToken,
    body
  ],
  queryFn: () =>
    fetch('https://setvi.thoughtspot.cloud/api/rest/2.0/metadata/tml/export', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${thoughspotUserAccessToken}`
      },
      body: JSON.stringify({
        edoc_format: 'JSON',
        export_associated: true,
        ...body
      })
    }).then(response => response.json()),
  onError: () => {}, // On some links this throw generic Error
  enabled: !!thoughspotUserAccessToken,
  cacheTime: 0
});
